import { render } from "./ProductInventoryLocationListPage.vue?vue&type=template&id=2ee99676&scoped=true"
import script from "./ProductInventoryLocationListPage.vue?vue&type=script&lang=js"
export * from "./ProductInventoryLocationListPage.vue?vue&type=script&lang=js"

import "./ProductInventoryLocationListPage.vue?vue&type=style&index=0&id=2ee99676&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ee99676"

export default script